import React from 'react'
import { Volume2 } from 'react-feather'
import { buildURL } from 'react-imgix'
import styled from 'styled-components'

import Hero from '../../components/Hero'
import { CONTAINER_WIDTH } from '../../theme'
import { MEDIA_QUERY_DESKTOP } from '../../utils/media-query'
import Concept from './Concept'
import Faq from './Faq'
import Roadmap from './Roadmap'
import SubscribeSection from './SubscribeSection'
import Team from './Team'
import VoidInfo from './VoidInfo'

const Image = styled.img`
  margin-top: 2rem;
  object-fit: cover;
  object-position: 50% 50%;

  @media (max-width: ${CONTAINER_WIDTH}px) {
    width: 100% !important;
    height: 100% !important;
  }
`

const Description = styled.div`
  margin-top: 1rem;
  margin-bottom: 2rem;

  ${MEDIA_QUERY_DESKTOP} {
    max-width: 536px;
    margin-top: 2rem;
    margin-bottom: 2rem;
    font-size: 18px;
  }
`

const ButtonPronounce = styled.button`
  display: inline-block;
  margin: 0;
  padding: 0;
  background: none transparent;
  border: 0;
  -webkit-appearance: none;
  color: rgba(255, 255, 255, .5);
  line-height: 1;
  transition: color 120ms ease;
  transform: translateY(-2px);

  &:hover {
    color: rgba(255, 255, 255, .7);
  }
`

const optimizedHelixUri = buildURL('https://triptcip.imgix.net/web-assets/synth-info.jpg', {
  quality: 100,
  width: 673
})

const LearnView = () => {
  const handleBtnPronounceClick = async () => {
    const AudioContext = window.AudioContext || window.webkitAudioContext
    const context = new AudioContext()
    const source = context.createBufferSource()

    source.buffer = await fetch('/audio/pronounce.mp3')
      .then(res => res.arrayBuffer())
      .then(ArrayBuffer => context.decodeAudioData(ArrayBuffer))

    source.connect(context.destination)
    source.start()
  }

  return (
    <>
      <Hero
        image={(
          <Image
            src={optimizedHelixUri}
            width={673}
            height={481}
            Alt='Void Inside'
          />
        )}
        titleFontSize={64}
        title={(
          <>
            Synthesized Generative Art
          </>
        )}
        description={(
          <Description>
            Our mission is to create a unique experience and tight community between the worlds of visual art, music and crypto.
            <br />
            <br />
            Triptcip
            {' '}
            <ButtonPronounce onClick={handleBtnPronounceClick}>
              <Volume2 />
            </ButtonPronounce>
            {' '}
            is a first of it's kind platform to introduce real-time visual synthesis into the NFT space, combined with electronic music.
            <br />
            <br />
            Essentially, Triptcip NFTs are a sequence of math equations for your computer's graphic card.
            Every playback is slightly unique, and because everything is rendered in real-time, NFTs on Triptcip have an uncomparable visual quality.
            <br />
            <br />
            But first, let's talk about VOID...
          </Description>
        )}
      />
      <VoidInfo />
      <Concept />
      <Roadmap />
      <Faq />
      <Team />
      <SubscribeSection />
    </>
  )
}

export default LearnView
